import 'remixicon/fonts/remixicon.css';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useAppSelector } from '../../store/Hooks';
import { Task } from '../../store/viewmodels/TaskViewModel';
import { StudentData } from '../../store/viewmodels/StudentViewModel';
import { getLogos } from '../../utils/TaskContentServices';
import TaskInfo from './TaskInfo';
import { isTaskDone } from '../../utils/TaskNavigationServices';


function Tasks() {
    let { path } = useRouteMatch();

    return (
        <div className="border mx-6 w-full">
            <Switch>
                <Route path={`${path}/:taskId`}>
                    <TaskInfo path={path} />
                </Route>
                <Route path={`${path}/`}>
                    <TaskList />
                </Route>
            </Switch>
        </div>
    );
}

function TaskList() {
    const studentData = useAppSelector(state => state.studentData);
    const tasks: Task[] = studentData.student.task_access_list;

    if (!tasks) { return <div></div> }

    let items: JSX.Element[] = []
    for (let i = 0; i < tasks.length; i++) {
        items.push(<TaskItem key={"task" + tasks[i].id} task={tasks[i]} studentData={studentData} />);
    }

    return (
        <div className="bg-white flex flex-wrap">
            {items}
        </div>
    );
}

interface TaskItemProps {
    task: Task,
    studentData: StudentData
}

function TaskItem(props: TaskItemProps) {
    let theme = "";
    if (props.task) {
        theme = props.task.theme === "NONE" ? props.task.name : props.task.theme;
    } else {
        theme = props.studentData.loadingState
    }

    let altText = theme === "NONE" ? "logo" : theme;
    const themeImg = props.task.logo?.logo ?
        <img className="p-1 h-32 sm:w-40 h-auto m-auto" src={getLogos(props.task.logo.logo)} alt={altText} />
        : <></>;

    if (props.task.one_time_only) {
        let isDone: boolean = isTaskDone(props.task, props.studentData.student);
        if (isDone) return (<></>);
    }

    return (
        <div>
            <Link to={'/student/tasks/' + props.task.id} className="block group hover:bg-teal-50">
                <div className="items-center px-4 py-4 sm:px-6">
                    <div className="min-w-0 items-center">
                        <div className="flex-shrink-0">
                            {themeImg}
                        </div>
                        <div className="min-w-0 text-center">
                            <p className="text-sm font-medium text-teal-600">{theme}</p>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
}


export default Tasks;
